module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GBy68N/tc-custom/9798886932157.jpg?1716663068565",
      "alt": "This image is the cover for the book Whispers of Joy and Murmurs of Love"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Whispers of Joy and Murmurs of Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("In a unique world of seven nations, beautifully united by a common language but jealously separated by ideological rivalries, a powerful emperor uses diplomacy to overturn an age-old cultural legislation that bars inter-state marriage, to pave the way for his daughter to marry a handsome poor young man from an enemy state.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("While the scrapping of the cultural taboo is being resisted with intense protestations throughout the region, especially in Voberia, the emperor's own kingdom, a beautiful lady elsewhere, lies in wait to steal away the heart of the fine-looking poor man from the flamboyant princess.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("However, in the midst of the protestations, a world-shaking historical discovery changes the hearts of the Voberians and sways them to support the marriage, and even own it.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("What is this crucial historical discovery? And how does it change the socio-cultural topology of the entire region? Each and every plot in this hilarious, nail-biting politico-romantic thriller opens the eyes of the human heart, and sends you on a sentimental journey to discover the propelling forces of pure love.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  })]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daniel Brande\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 8pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Daniel Brande is a prolific writer, consummate marketing practitioner, and eminent award-winning journalist with over 30 years of experience. Blending journalism with marketing, Daniel creates distinctive media products. At the Ghana Broadcasting Corporation and United Nations where he worked for over three decades, his media productions stood out. As a Reuters Fellow at the University of Oxford, Daniel has been a driving force in the media space, freelancing for several international radio stations and magazines with impactful, inventive works. Conveyed in succinct, vivid, lucid language, Daniel’s writings and radio productions make an impression on society.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0